import { render, staticRenderFns } from "./AppSupport.vue?vue&type=template&id=5c5d0d2e&scoped=true&"
import script from "./AppSupport.vue?vue&type=script&lang=js&"
export * from "./AppSupport.vue?vue&type=script&lang=js&"
import style0 from "./AppSupport.vue?vue&type=style&index=0&id=5c5d0d2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d0d2e",
  null
  
)

export default component.exports